/**
 * PATH: apps/quote/src/components/builder/paste-mapping-modal/MappingRow.tsx
 * PURPOSE: Single row for mapping a source column to a target field
 */

import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { PasteMappingModalProps } from './types'

export function MappingRow({ sourceIndex, sourceHeader, sampleValues, targetField, availableFields, onChangeTarget, usedFields }: {
  sourceIndex: number; sourceHeader: string; sampleValues: string[]
  targetField: string | null; availableFields: PasteMappingModalProps['availableFields']
  onChangeTarget: (field: string | null) => void; usedFields: Set<string>
}) {
  const isIgnored = targetField === null
  return (
    <div className={cn('grid grid-cols-[40px_1fr_40px_1fr] gap-2 items-center py-2 px-3 border-b border-slate-100 dark:border-slate-800', isIgnored && 'opacity-50')}>
      <div className="text-xs text-slate-400 font-mono text-center">{sourceIndex + 1}</div>
      <div className="min-w-0">
        <div className="text-sm font-medium text-slate-900 dark:text-white truncate">{sourceHeader || `Column ${sourceIndex + 1}`}</div>
        <div className="text-xs text-slate-400 truncate">{sampleValues.slice(0, 3).join(', ')}</div>
      </div>
      <div className="flex justify-center"><ArrowRight className={cn('w-4 h-4', isIgnored ? 'text-slate-300' : 'text-blue-500')} /></div>
      <select value={targetField || ''} onChange={(e) => onChangeTarget(e.target.value || null)} className={cn('w-full px-2 py-1.5 text-sm rounded border', isIgnored ? 'bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-400' : 'bg-white dark:bg-slate-800 border-blue-300 dark:border-blue-600 text-slate-900 dark:text-white')}>
        <option value="">— Ignore —</option>
        {availableFields.map(field => (<option key={field.id} value={field.id} disabled={usedFields.has(field.id) && targetField !== field.id}>{field.label} {field.required && '*'}</option>))}
      </select>
    </div>
  )
}
